import { IState } from '../../store';

export function onlineRegistrationAvailableSelector(state: IState): boolean {
  return state.offerData.isOnlineRegistrationAvailable || false;
}
